import { LogInfo } from 'utils/logging';
import { GlobalContextType } from 'types';
import { triadSuperFetch } from 'utils/superFetch';
import { appendGAValue } from 'utils/thirdPartyScripts';
import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { APIError } from 'utils/errors/APIError';

interface UserSessionResponse {
  SessionId: string;
  PageViewId: string;
  spc: string;
  ppc: string;
  propertyOrigin: string;
  campaignType: string;
  trackingSchoolCode: string;
  isClickUser: boolean;
  adPlatformSource: string;
}

interface UserSession {
  sessionId: GlobalContextType['sessionInfo']['userSessionId'];
  pageViewId: GlobalContextType['sessionInfo']['pageViewId'];
  floodLightActivityFilters: GlobalContextType['sessionInfo']['floodLightActivityFilters'];
}

export async function generateUserSession(
  queryParams: Record<string, string>,
  siteMeta: GlobalContextType['siteMeta']
): Promise<UserSession> {
  LogInfo('generateUserSessionId', {
    description: 'fetching session id',
  });

  const [apiError, response] = await triadSuperFetch<UserSessionResponse>(
    `${TRIAD_PROXY_ROUTE}/GetNewSession`,
    {
      method: 'GET',
      timeout: 5000,
      queryParams: {
        ...queryParams,
        tmsurl: window.location.pathname,
        tmshost: window.location.host,
        tmsaq: '1',
        schoolCode: siteMeta.schoolCode,
      },
      retry: {
        maxAttempts: 5,
        waitTimeBetweenFails: 2000,
      },
    }
  );

  if (apiError) {
    throw apiError;
  }

  if (!response) {
    throw new APIError(
      'Failed empty response',
      500,
      `${TRIAD_PROXY_ROUTE}/GetNewSession`
    );
  }

  if (response.SessionId === '00000000-0000-0000-0000-000000000000') {
    throw new APIError(
      'Failed token not unique',
      500,
      `${TRIAD_PROXY_ROUTE}/GetNewSession`
    );
  }

  if (!response.SessionId) {
    throw new APIError(
      'Failed empty sessionId received',
      500,
      `${TRIAD_PROXY_ROUTE}/GetNewSession`
    );
  }

  const {
    SessionId,
    PageViewId,
    spc,
    ppc,
    propertyOrigin,
    campaignType,
    trackingSchoolCode,
    isClickUser = false,
    adPlatformSource,
  } = response;

  if (spc) {
    appendGAValue('spc', spc);
  }

  if (ppc) {
    appendGAValue('ppc', ppc);
  }

  return {
    sessionId: SessionId,
    pageViewId: PageViewId,
    // TODO: [T1-11350] Rename from floodLightActivityFilters to userAttributionFilters
    floodLightActivityFilters: {
      trackingSchoolCode,
      propertyOrigin,
      campaignType,
      isClickUser,
      adPlatformSource,
    },
  };
}
